module.exports = __webpack_public_path__ + "static/media/Logistic Stack - GBR network - 25-09-2024.39f76454.png";